import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-secondary" data-id="element-131" data-mp="1o2vhap4uen6k">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-132" data-mp="223el1k29z72x">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row gap-8 md:gap-10 items-center bg-card border border-success/20 rounded-[32px] p-8 md:p-12 max-w-[860px] mx-auto relative overflow-hidden text-center md:text-left" data-id="element-133" data-mp="2223g3gx3fta8">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-success to-transparent" data-id="element-134" data-mp="1j52co0j6u18e" />
          
          <div className="shrink-0 w-[120px] h-[120px] rounded-full bg-gradient-to-br from-success/15 to-success/5 border-2 border-success/40 flex flex-col items-center justify-center p-4" data-id="element-135" data-mp="1ecsooq1mvb8r">
            <ShieldCheck className="w-8 h-8 text-success mb-1" data-id="element-136" data-mp="lpy4zvcn4fwc" />
            <div className="font-display text-2xl font-black text-success leading-none" data-id="element-137" data-mp="ozjaqhs356o3">7</div>
            <div className="text-[10px] font-extrabold text-success tracking-wider uppercase leading-tight mt-1" data-id="element-138" data-mp="tymi48vjfoz8">días de<br data-id="element-139" data-mp="ypbcpx2il22l" />garantía</div>
          </div>
          
          <div data-id="element-140" data-mp="ypurx60s5ccx">
            <h3 className="font-display text-2xl font-bold text-white mb-3" data-id="element-141" data-mp="yrfm2uj6mta9">
              Garantía de Transformación de 7 Días
            </h3>
            <p className="text-[15px] text-gray-400 leading-relaxed" data-id="element-142" data-mp="61feup17l448">
              Aplica el sistema durante 7 días completos. Si no sientes un cambio real en tu claridad, tu paz mental o tu capacidad para manifestar, escríbenos y te devolvemos <strong className="text-white" data-id="element-143" data-mp="ezsi6ln351qn">cada centavo</strong>, sin preguntas, sin dramas. El riesgo es 100% nuestro. La transformación es tuya.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}